module.exports = __webpack_public_path__ + "img/KFK_VOL.7851678b.png";